import { request } from '@langlois/request';

export async function register ({ commit, state }, body) {
	try {
		const url = new URL(`${process.env.VUE_APP_API_URI}/club/club`);

		const response = await request.post(url, body);

		if (response.ok) {
			const { id } = await response.json();

			commit(`club`, {
				...state.club,
				id
			});

			return id;
		}
	} catch (error) {
		commit(`vcl/notificationBar/show`, {
			text: `Encountered an error while creating the club.`,
			type: `warning`
		}, { root: true });
	}
}
